import React, { use, useState } from 'react'
import Whatsapp from './Whatsapp'

export default function main({ admin, userDetail, allDetail }) {
    const [currentTab, setCurrentTab] = useState("whatsapp")

    const handleTab = (type) => {
        setCurrentTab(type)
    }

    return (
        <>
            <div className="container-fluid details-new">
                <div className="btn-group btn-grp-own" role="group" aria-label="onboard-btn" style={{ marginTop: '10px', padding: '10px' }}>
                    {/* <button className="btn btn-outline-primary" style={{ background: currentTab === 'email' ? '#1D3557' : '#F1F7FF', color: currentTab === 'email' ? '#fff' : '#000' }} onClick={() => handleTab('email')}> Email </button> */}
                    <button className="btn btn-outline-primary" style={{ background: currentTab === 'whatsapp' ? '#1D3557' : '#F1F7FF', color: currentTab === 'whatsapp' ? '#fff' : '#000' }} onClick={() => handleTab('whatsapp')} > Whatsapp </button>
                    {/* <button className="btn btn-outline-primary" style={{ background: currentTab === 'SMS' ? '#1D3557' : '#F1F7FF', color: currentTab === 'SMS' ? '#fff' : '#000' }} onClick={() => handleTab('SMS')} > SMS </button>
                    <button className="btn btn-outline-primary" style={{ background: currentTab === 'Notification' ? '#1D3557' : '#F1F7FF', color: currentTab === 'Notification' ? '#fff' : '#000' }} onClick={() => handleTab('Notification')} > Notification </button>
                    <button className="btn btn-outline-primary" style={{ background: currentTab === 'comments' ? '#1D3557' : '#F1F7FF', color: currentTab === 'comments' ? '#fff' : '#000' }} onClick={() => handleTab('comments')} > Comments </button> */}

                </div>
                <div className="container-fluid details-new">
                    {
                        currentTab == "whatsapp" ?
                            <Whatsapp userDetail={userDetail} />
                            : ""}
                </div>

            </div>
        </>
    )
}
